export const CODE = {
    OK_CODE: 200,
    CREATED: 201,
    BAD_REQUEST_CODE: 400,
    UNAUTHORIZED_CODE: 401,
    VALIDATION_CODE: 422,
    NO_CONTENT: 204,
    INTERNAL_SERVER_ERROR: 500
}

export const VALIDATION_MESSAGE = {
    CATCH_ERROR: "Something went wrong. Please try again.",
    FULL_NAME_MAX: 'Full name must be at most 50 characters.'
}

export const StorageConstants = {
    ACCESS_TOKEN: 'access_token',
    FCM_TOKEN: 'fcm_token',
    USER_DETAIL: 'user_details',
    USER_SESSION: 'user_session',
    APP_SETTINGS: 'app_settings',
    OTP_START_TIME: 'otp_start_time',
    DASHBOARD: 'dashboard',
    PLATFORM: 'platform',
    COOKIE_CONSENT: 'cookie_consent',
};

export const PAGES = {
    pageIndex: 0,
    pageSize: 10
}

export const VerifyOtpTypes = {
    RESET_PASSWORD: 'reset_password',
};


export const ApiTypes = {
    GET: 'GET',
    POST: 'POST',
    FORM_DATA: 'FORM_DATA',
};

export const OtpVerifyTypes = {
    MAIL_VERIFY: 'MAIL_VERIFY',
    FORGOT_PASSWORD: 'FORGOT_PASSWORD',
};

export const FREQUENCY_TYPES = {
    ONCE_ONLY: 0,
    DAILY: 1,
    WEEKLY: 2,
    MONTHLY: 3,
    YEARLY: 4,
};

export const LOCATION_TYPES = {
    COUNTRY: 1,
    STATE: 2,
    LOCALITY: 3,
};

export const HOUSEHOLD_TYPES = {
    ADMIN: 0,
    PARTNER: 1,
    ROOMMATE: 2,
    FAMILY_MEMBERS: 3,
};

export const HOUSEHOLD_TYPES_NAME = {
    0: 'Household Admin',
    1: 'Partner',
    2: 'Roommate',
    3: 'Family Member',
};

export const USER_ROLE_TYPES = {
    IS_FOR_FIRST_TIME: 2,
    GROUP_ADMIN: 1,
    MEMBER: 2
}

export const UPGRADE_PLAN = "Please upgrade plan to allow this feature."

export const PERMISSIONS = {
    ALLOW_INVITE: "ALLOW_INVITE",
    CHORES_WITH_NATIONAL_PRICE: "CHORES_WITH_NATIONAL_PRICE",
    CHORES_WITH_LOCALITY_BASED_PRICES: "CHORES_WITH_LOCALITY_BASED_PRICES",
    EXPENSES: "USER_EXPENSES",
    CONTRIBUTION: "CONTRIBUTION",
    PAYEMTS: "PAYEMTS",
    REPORTS: "REPORTS",
    CHORES: "CHORES",
    OPPORTUNITY_COST: "OPPORTUNITY_COST",

    // Member limits
    TWO_MEMBERS: "2_MEMBERS",
    FIVE_MEMBERS: "5_MEMBERS",
    MULTIPLE_HOUSEHOLDS: "MULTIPLE HOUSEHOLDS",

    // Chores
    BASIC_CHORES: "BASIC_CHORES",
    PREMIUM_CHORES: "PREMIUM_CHORES",

    // Expenses
    JOINT_ACCOUNT_EXPENSES: "JOINT_ACCOUNT_EXPENSES",

    // Split Types
    INCOME_ADJUSTED_SPLIT: "INCOME_ADJUSTED_SPLIT",
    EVEN_SPLIT: "EVEN_SPLIT",
    TIME_ADJUSTED_SPLIT: "TIME_ADJUSTED_SPLIT",
    HYBRID_ADJUSTED_SPLIT: "HYBRID_ADJUSTED_SPLIT",
    CUSTOM_SPLIT: "CUSTOM_SPLIT",

    // Payments & Notifications
    IN_APP_PAYMENTS: "IN_APP_PAYMENTS",
    NOTIFICATIONS: "NOTIFICATIONS",
};